import { BaseOrder } from "./BaseOrder";
import { OrderId } from "./OrderId";
import { OrderResponse } from "./OrderResponse";
import { OrderStatus } from "./OrderStatus";
import { OrderTypes } from "./OrderTypes";
import { OrderOtherDocumentRequest } from "./Order";
import { DocumentationAreaActorOrderRetrievalMethod } from "./DocumentationAreaActorOrderRetrievalMethod";

export type OrderOtherDocumentParams = {
  id: OrderId;
  request: OrderOtherDocumentRequest;
  responses: OrderResponse[];
  retrievalMethods: DocumentationAreaActorOrderRetrievalMethod[];
  status: OrderStatus;
};

export type OrderOtherDocumentCreateParams = {
  id?: OrderId;
  request: OrderOtherDocumentRequest;
};

export class OrderOtherDocument extends BaseOrder<OrderOtherDocumentRequest> {
  constructor({ id, request, responses, retrievalMethods, status }: OrderOtherDocumentParams) {
    super(id, OrderTypes.OTHER_DOCUMENT, request, responses, retrievalMethods, status);
  }

  static fromPrimitives(data: any): OrderOtherDocument {
    return new OrderOtherDocument({
      id: data.id,
      request: data.request,
      responses:
        data.responses?.map(
          (response: any) =>
            new OrderResponse({
              id: response.id,
              createdAt: new Date(response.createdAt),
              inputFiles: response.inputFiles || [],
              outputFiles: response.outputFiles || [],
              status: response.status,
              statusMessages: response.statusMessages || [],
              retrievalMethodOutput: response.retrievalMethodOutput || null,
            }),
        ) || [],
      retrievalMethods:
        data.retrievalMethods?.map(
          (method: any) =>
            new DocumentationAreaActorOrderRetrievalMethod({
              name: method.name,
              config: method.config || null,
            }),
        ) || [],
      status: data.status,
    });
  }
}
